/* eslint-disable react/prop-types */
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, Divider, Grid, IconButton, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { CancelPresentationRounded } from '@mui/icons-material';
import styles from './style';

const DeleteConfirmationModal = ({ open, handleDelete, handleClose, deleteRow, actionName = 'Delete', actionDesc }) => {
  const classes = styles();

  return (
      <Dialog
        open={open}
        onClose={() => {
          handleClose(false);
        }}
        fullWidth={true}
        className={classes.dialogModal}
      >
        <Box className={classes.dialogTitle}>
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: '1.3rem' }}>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid item>Attention!</Grid>
              <Grid item>
                <IconButton
                  onClick={() => {
                    handleClose(false);
                  }}
                >
                  <CancelPresentationRounded fontSize='large' />
                </IconButton>
              </Grid>
            </Grid>
          </Typography>
        </Box>
        <Divider />
        <DialogContent style={{ marginTop: '2px' }}>
          <DialogContentText align='center' style={{ marginLeft: '-0.7rem' }} color={'black'} fontSize={'18px'} fontWeight='bold' id="alert-dialog-description">
            {actionDesc || 'Are you sure?'}
          </DialogContentText>
        </DialogContent>
        <Grid container item justifyContent='center' marginBottom='2rem'>
          <DialogActions>
            <Button
              style={{ backgroundColor: '#444', width: '100px' }}
              onClick={() => {
                handleDelete(deleteRow);
              }}
            >
              {actionName}
            </Button>
          </DialogActions>
        </Grid>
      </Dialog>
  );
};

DeleteConfirmationModal.propTypes = {
  open: PropTypes.any,
  handleDelete: PropTypes.any,
  handleClose: PropTypes.any,
  deleteRow: PropTypes.any
};

export default DeleteConfirmationModal;
